import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { imgUrl } from "@/lib/api";

export const PreviewModal = ({ product, open, onClose, startIndex = 0 }) => {
  if (!product) return null;
  const images = product.preview_images || [];
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        data-testid="preview-modal"
        className="max-h-[90vh] max-w-2xl overflow-y-auto rounded-[2rem] border-4 border-sky-100 bg-white p-6"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold text-slate-800">
            {product.name} — Sample Pages
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-5">
          {images.map((src, i) => (
            <img
              key={src}
              src={imgUrl(src)}
              alt={`${product.name} sample page ${i + 1}`}
              loading={i === startIndex ? "eager" : "lazy"}
              className="w-full rounded-2xl border-2 border-slate-100 shadow-md"
            />
          ))}
        </div>
        <p className="mt-4 rounded-2xl bg-sky-50 px-5 py-3 text-center text-sm font-semibold text-slate-500">
          These are sample pages. The full PDF unlocks after your payment is verified.
        </p>
      </DialogContent>
    </Dialog>
  );
};
